import React from 'react';

import { AppShell, Navbar, useMantineTheme, ScrollArea } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useNavBarStateContext } from "../context/navBarStateContext";

import { useLoginContext } from "../context/loginContext";

import IdleTimer from "../idleTimer/idleTimer";
import { brand, utils } from "../utils/globalVariables";
import BrandComponent from "./BrandComponent";
import MenuList from "./MenuList";

const LayoutAppShell = ({ children, stateMenuList, stateMenu, stateLocalStorageIdleTimerName }) => {

    const theme = useMantineTheme();
    const { navBarState } = useNavBarStateContext();
    const matchesMinMD = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    React.useEffect(() => {
        document.title = brand.longName;
    }, []);

    React.useEffect(() => {
        const timer = utils.useIdleTimer === false ? null : new IdleTimer({
            localStorageIdleTimeName: stateLocalStorageIdleTimerName,
            onTimeout: () => {
                handleSetLoginContext(null)
            },
            onExpired: () => {
                if (!loginContext) {
                    handleSetLoginContext(null);
                } else {
                    if (!loginContext.hasOwnProperty('syswebapp')) {
                        handleSetLoginContext(null);
                    }
                }
            },
            onInterval: () => {
                /* some codes */
            }
        });

        return () => utils.useIdleTimer === false ? null : timer.cleanUp();
    }, [handleSetLoginContext, loginContext, stateLocalStorageIdleTimerName]);

    return (
        <React.Fragment>
            <AppShell
                id='agu'
                // classNames={{
                //     root: 'asu'
                // }}
                styles={() => ({
                    main: {
                        // backgroundColor: matchesMinMD ? (theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[8]) : (theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[8]),

                        paddingTop: matchesMinMD ? 'var(--mantine-header-height, 0px)' : 'var(--mantine-header-height, 0px)',
                        // paddingBottom: 0,
                        // margin: 0,

                        // paddingRight: 'calc(var(--mantine-aside-width, 0px) + 0rem)',
                        paddingRight: navBarState ? (matchesMinMD ? 'calc(var(--mantine-aside-width, 0px) + 0rem)' : `0rem !important`) : `0rem !important`,
                        paddingLeft: navBarState ? (matchesMinMD ? 'calc(var(--mantine-navbar-width, 0px) + 0rem)' : `0rem !important`) : `0rem !important`,

                        width: 'calc(100vw - 2rem)',

                        backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[8],
                    },
                })}

                layout="alt"
                hidden={false}
                // navbarOffsetBreakpoint={navBarState ? 'sm' : 100000000000}
                navbarOffsetBreakpoint={navBarState ? 'md' : 100000000000}
                navbar={
                    <Navbar
                        // hiddenBreakpoint={navBarState ? 'sm' : 100000000000}
                        hiddenBreakpoint={navBarState ? 'md' : 100000000000}
                        hidden

                        style={{
                            borderColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7],
                            backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[8],
                        }}

                        width={{
                            sm: 225,
                            xl: 250,
                        }}
                    >
                        <Navbar.Section
                            pt='lg'
                            pb='md'

                            px='lg'
                        >
                            <BrandComponent />
                        </Navbar.Section>

                        <Navbar.Section
                            grow
                            component={ScrollArea}
                            offsetScrollbars={false}

                            py={0}
                            px='xs'
                        >
                            <MenuList
                                stateMenuList={stateMenuList}
                                stateMenu={stateMenu}
                                fnClickMenu={() => null}
                            />
                        </Navbar.Section>
                    </Navbar>
                }
            >
                {children}
            </AppShell>

        </React.Fragment>
    )
}

export default LayoutAppShell;